import { useState } from 'react';
import BanquetHelpPanel from './BanquetHelpPanel';
import BanquetHallMaster from './BanquetHallMaster';
import BanquetPartitionMaster from './BanquetPartitionMaster';
import BanquetCombinationMaster from './BanquetCombinationMaster';
import BanquetCombinationMapMaster from './BanquetCombinationMapMaster';
import BanquetSeatingTypeMaster from './BanquetSeatingTypeMaster';
import BanquetServiceModeMaster from './BanquetServiceModeMaster';
import BanquetSlotMaster from './BanquetSlotMaster';
import BanquetLayoutMaster from './BanquetLayoutMaster';

function BanquetMastersHub({ token, selectedProperty, selectedOutletId = '', showHelp = false, onOpenFaq }) {
  const [activeTab, setActiveTab] = useState('hall');

  const tabs = [
    { key: 'hall', label: 'Hall' },
    { key: 'partition', label: 'Partition' },
    { key: 'combination', label: 'Combination' },
    { key: 'map', label: 'Combination Map' },
    { key: 'seating', label: 'Seating Type Master' },
    { key: 'service-mode', label: 'Service Mode Master' },
    { key: 'slot', label: 'Slot Master' },
    { key: 'layout', label: 'Seating Layout' }
  ];

  const tabButtonStyle = (isActive) => ({
    padding: '0.5rem 0.8rem',
    borderRadius: '999px',
    border: isActive ? '1px solid var(--theme-primary)' : '1px solid #cbd5e1',
    background: isActive ? 'var(--theme-primary)' : 'var(--theme-bg-light)',
    color: isActive ? '#fff' : '#1f2937',
    fontWeight: 600,
    cursor: 'pointer'
  });

  return (
    <div className="page-shell">
      <h2 style={{ color: 'var(--theme-primary)', marginBottom: '0.4rem' }}>Banquet - Masters</h2>
      <div style={{ color: '#475569', marginBottom: '0.8rem' }}>Configure halls, partitions, combinations, seating types and layouts in one place.</div>
      <BanquetHelpPanel visible={showHelp} onOpenFaq={onOpenFaq} />

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.45rem', marginBottom: '1rem' }}>
        {tabs.map((tab) => (
          <button key={tab.key} type="button" onClick={() => setActiveTab(tab.key)} style={tabButtonStyle(activeTab === tab.key)}>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="card">
        {activeTab === 'hall' && (
          <BanquetHallMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
        {activeTab === 'partition' && (
          <BanquetPartitionMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
        {activeTab === 'combination' && (
          <BanquetCombinationMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
        {activeTab === 'map' && (
          <BanquetCombinationMapMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
        {activeTab === 'seating' && (
          <BanquetSeatingTypeMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
        {activeTab === 'service-mode' && (
          <BanquetServiceModeMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
        {activeTab === 'slot' && (
          <BanquetSlotMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
        {activeTab === 'layout' && (
          <BanquetLayoutMaster
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedOutletId}
            showHelp={false}
            onOpenFaq={onOpenFaq}
          />
        )}
      </div>
    </div>
  );
}

export default BanquetMastersHub;
